import "./customLinkSiideNav.scss";
import { ReactComponent as Exit } from "../../../../../../assets/exitIcon.svg";
import TextField from "../../../../../../common/components/inputFields/textFields/textField";
import { Color } from "../../../../../../common/style/colors";
import { ReactComponent as CopyIcon } from "../../../../../../assets/copyIcon.svg";
import { useEffect, useState } from "react";
import { CustomLinkModel } from "../../../../models/customLinkModel";

export default function CustomLinkSideNav(props: {
  customLinkData?: CustomLinkModel;
  onClickClose?: () => void;
  onChange?: (e: CustomLinkModel) => void;
}) {
  const domain = "campaign.techsauce.co/";
  const [customLinkData, setCustomLinkData] = useState<CustomLinkModel>(
    props.customLinkData ?? ({} as CustomLinkModel)
  );

  useEffect(() => {
    props.onChange?.(customLinkData);
  }, [customLinkData]);

  return (
    <div className="style-side-background">
      <div className="style-side-nav">
        <Exit
          height={20}
          width={20}
          style={{ alignSelf: "flex-end", cursor: "pointer" }}
          onClick={props.onClickClose}
          stroke={"black"}
        />
        <h3 className="styleTitle">Customize link</h3>
        <p className="styleDescription">
          You can customize your share link preview UI by filling this form!
        </p>
        <hr style={{ width: "100%" }} />
        <TextField
          initialValue={customLinkData.linkSuffix ?? ""}
          title="Custom link"
          prefix={
            <p
              style={{
                margin: "0",
                color: Color().disableColor,
                fontSize: "12px",
              }}
            >
              {domain}
            </p>
          }
          suffix={
            <CopyIcon
              height={20}
              width={20}
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigator.clipboard.writeText(
                  domain + (customLinkData.linkSuffix ?? "")
                )
              }
            />
          }
          onChange={(e) =>
            setCustomLinkData({ ...customLinkData, linkSuffix: e })
          }
        />
        <hr style={{ width: "100%" }} />
        <TextField
          initialValue={customLinkData.title ?? ""}
          title="title"
          onChange={(e) => setCustomLinkData({ ...customLinkData, title: e })}
        />
        <TextField
          initialValue={customLinkData.description ?? ""}
          title="description"
          onChange={(e) =>
            setCustomLinkData({ ...customLinkData, description: e })
          }
        />
      </div>
    </div>
  );
}
